import type { AdminAiScanFindingRowProps } from "../../models/admin-ai-scans.models";
import { adminAiScansStyles } from "../../styles/admin-ai-scans.styles";
import { getAdminAiScanFindingTitle } from "../../utils/admin-ai-scans.utils";
import AdminAiScanFindingSummary from "./AdminAiScanFindingSummary";

// Use a native button so tapping or pressing Enter opens the full finding with normal keyboard behavior.
const AdminAiScanFindingRow = ({ finding, source, onOpen }: AdminAiScanFindingRowProps) => (
  <button
    type="button"
    className={`${adminAiScansStyles.findingSurface} block w-full transition-colors hover:border-slate-400 hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green dark:hover:bg-gray-700/50`}
    onClick={onOpen}
    aria-label={`Open finding: ${getAdminAiScanFindingTitle(finding)}${source ? `, ${source.businessObjectLabel}` : ""}`}
    aria-haspopup="dialog"
    data-test="admin-ai-scan-finding-row"
  >
    <AdminAiScanFindingSummary finding={finding} source={source} />
  </button>
);

export default AdminAiScanFindingRow;
